// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Mismatch_overlay__2I51F"};